import classes from "./ProgressBar.module.css"

const ProgressBar = (props) => {
    const { mainProgress, subProgress, total } = props


    function calculatePercentage(ticketsSold, totalTickets) {
        return totalTickets > 0 ? Math.min(100, Math.max(0, (ticketsSold / totalTickets) * 100)) : 0;
    }

    return (
        <div className={classes.main}>
            <div className={classes.labels}>
                <p>{mainProgress} платних · {subProgress} загалом</p>
                <p>Ціль: {total}</p>
            </div>
            <div className={classes.bar}>
                <div className={classes.mainBar} style={{ width: `${calculatePercentage(mainProgress, total)}%` }}/>
                <div className={classes.subBar} style={{ width: `${calculatePercentage(subProgress, total)}%` }}/>
            </div>
        </div>
    )
}

export default ProgressBar